import { Injectable } from '@angular/core';
import { LogApiService } from '@bcmServices/index';
import { environment } from '@env/environment';
import { BcmService } from '../../modules/bcm/bcm.service';

@Injectable({
    providedIn: 'root'
})
export class AppLoggingService {

    constructor(
        private _logApiService: LogApiService,
        private _bcmService: BcmService,
    ) {
    }

    logError(message: string, error: Error, stack: any): void {

        this._logApiService.add({
            error: error,
            category: 'Front-End',
            stack,
            tenant_id: this._bcmService.tenant?.id ?? null,
        }).subscribe();

        if (!environment.production) {
            console.error(error);
        }
    }
}
